import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

// import colors from 'vuetify/lib/util/colors'



Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#2B8590',
                secondary: '#c4b19c',
                tertiary: '#ac9072',
                quaternary: '#ac9072',

                black: "#212429",
                grey: "#B5B5C3",
                yellow: "#dcae3b",
                red: "#FC4848",
                blue: "#2196F3",
                green: "#89C67A",

                table_red: '#FCEBEB',
            },
        },
        breakpoint: {
            thresholds: {

              /* xs: 0,
              sm: 576,
              md: 768,
              lg: 992,
              xl: 1200,
              xxl: 1400, */

                sm: 600,
                md: 728,
                lg: 984,
                xl: 1240,


            },
            scrollBarWidth: 24,
          },
    },
});
